import { z } from "zod";

const MODULE_STATES = [
  "OFF",
  "DRAFT",
  "UNPUBLISHED",
  "PUBLISHED",
  "ARCHIVED",
] as const;

export const moduleConfigEntrySchema = z.object({
  state: z.enum(MODULE_STATES),
  position: z.number().int().optional(),
  visible: z.boolean().optional(),
  /**
   * Admin choice to hide an enabled module from the member nav entirely
   * (main list and "More" overflow). Absent/false = shown. Orthogonal to
   * `visible`, the derived top-N main-list split.
   */
  hidden: z.boolean().optional(),
});

export type ModuleConfigEntry = z.infer<typeof moduleConfigEntrySchema>;

export const moduleConfigSchema = z.record(z.string(), moduleConfigEntrySchema);
export type ModuleConfig = z.infer<typeof moduleConfigSchema>;

/**
 * Fully normalized entry -- position, visible, and hidden are guaranteed
 * present.
 */
export type NormalizedModuleConfigEntry = Required<ModuleConfigEntry>;
export type NormalizedModuleConfig = Record<
  string,
  NormalizedModuleConfigEntry
>;
